import { Box } from '@mui/system';
import styled from 'styled-components';

export const ExpiredDateWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 64px - 50px);
  padding: 20px;
  box-sizing: border-box;
  text-align: center;
`;

export const TextContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 70%;
  height: 100%;
`;
